import { NodeModelTypeEnum } from '../enums';
import { Node } from '../Node';

export class CompressorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.Compressor,
    });
  }
}
